import {
  createMerchantsListUrl,
  createMerchantProfileUrl,
} from "@factories/safebuy-url-factory";
import {
  MerchantsListResponse,
  MerchantProfile,
  MerchantApiError,
} from "@interfaces/safebuy-users";
import { getCookie } from "cookies-next";

export async function getMerchantsList(): Promise<MerchantsListResponse | null> {
  try {
    // Remove user_id check since merchants list should be public
    // const userId = getCookie("user_id");
    // if (!userId || typeof userId !== "string") {
    //   console.error("User ID not found in cookies");
    //   return null;
    // }

    const response = await fetch(createMerchantsListUrl(), {
      method: "GET",
      next: { revalidate: 0 },
      credentials: "include", // This will automatically include cookies
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error(
        "Merchants list service error",
        response.status,
        response.statusText
      );
      return null;
    }

    const result = await response.json();
    return result as MerchantsListResponse;
  } catch (error) {
    console.error("Merchants list service error", error);
    return null;
  }
}

export async function getMerchantsListWithErrorHandling(): Promise<{
  data: MerchantsListResponse | null;
  error: MerchantApiError | null;
}> {
  try {
    // Remove user_id check since merchants list should be public
    // const userId = getCookie("user_id");
    // if (!userId || typeof userId !== "string") {
    //   return {
    //     data: null,
    //     error: {
    //       error: "Authentication error",
    //       message: "User ID not found in cookies",
    //     },
    // };

    const response = await fetch(createMerchantsListUrl(), {
      method: "GET",
      next: { revalidate: 0 },
      credentials: "include", // This will automatically include cookies
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        data: null,
        error: result as MerchantApiError,
      };
    }

    return {
      data: result as MerchantsListResponse,
      error: null,
    };
  } catch (error) {
    console.error("Merchants list service error", error);
    return {
      data: null,
      error: {
        error: "Network error",
        message: error instanceof Error ? error.message : "Unknown error",
      },
    };
  }
}

export async function getMerchantProfile(
  merchantId: string
): Promise<MerchantProfile | null> {
  try {
    // Remove user_id check since merchant profiles should be public
    // const userId = getCookie("user_id");
    // if (!userId || typeof userId !== "string") {
    //   console.error("User ID not found in cookies");
    //   return null;
    // }

    const response = await fetch(createMerchantProfileUrl(merchantId), {
      method: "GET",
      next: { revalidate: 0 },
      credentials: "include", // This will automatically include cookies
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error(
        "Merchant profile service error",
        response.status,
        response.statusText
      );
      return null;
    }

    const result = await response.json();
    return result as MerchantProfile;
  } catch (error) {
    console.error("Merchant profile service error", error);
    return null;
  }
}

export async function getMerchantProfileWithErrorHandling(
  merchantId: string
): Promise<{
  data: MerchantProfile | null;
  error: MerchantApiError | null;
}> {
  try {
    // Remove user_id check since merchant profiles should be public
    // const userId = getCookie("user_id");
    // if (!userId || typeof userId !== "string") {
    //   return {
    //     data: null,
    //     error: {
    //       error: "Authentication error",
    //       message: "User ID not found in cookies",
    //     },
    //   };

    const response = await fetch(createMerchantProfileUrl(merchantId), {
      method: "GET",
      next: { revalidate: 0 },
      credentials: "include", // This will automatically include cookies
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        data: null,
        error: result as MerchantApiError,
      };
    }

    return {
      data: result as MerchantProfile,
      error: null,
    };
  } catch (error) {
    console.error("Merchant profile service error", error);
    return {
      data: null,
      error: {
        error: "Network error",
        message: error instanceof Error ? error.message : "Unknown error",
      },
    };
  }
}
